var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftPanelClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_899_6621",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_899_6621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.25V6.75L10 10L13.5 13.25ZM4.39583 17C4.01199 17 3.68338 16.8633 3.41002 16.59C3.13667 16.3166 3 15.988 3 15.6042V4.39583C3 4.01197 3.13667 3.68337 3.41002 3.41002C3.68338 3.13667 4.01199 3 4.39583 3H15.6042C15.988 3 16.3166 3.13667 16.59 3.41002C16.8633 3.68337 17 4.01197 17 4.39583V15.6042C17 15.988 16.8633 16.3166 16.59 16.59C16.3166 16.8633 15.988 17 15.6042 17H4.39583ZM7 15.5V4.5H4.5V15.5H7ZM8.5 15.5H15.5V4.5H8.5V15.5Z",
    fill: "#DADADA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftPanelClose);
export default __webpack_public_path__ + "static/media/LeftPanelClose.77e7769b3001b77032dd5685135d6931.svg";
export { ForwardRef as ReactComponent };